import { render, staticRenderFns } from "./AppTheme.vue?vue&type=template&id=8fbb83c2"
import script from "./AppTheme.vue?vue&type=script&lang=js"
export * from "./AppTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports